<template>
  <footer class="bg-white">
    <div class="container">
      <div class="row pt-5 pb-3">
        <div class="col-12">
          <a href="https://rapidsoft.co.za">
            <img
              width="200"
              src="@/assets/img/rapid-logo.png"
              alt="Rapidsoft Logo"
              class="img-fluid my-3"
            />
          </a>
        </div>
      </div>


      <div class="row">
       
       
        <div class="col-md-6 col-lg-3 my-3">
          <i class="lni lni-phone-set text-primary font-size-26 mb-3"></i>
          <p>
            <a href="mailto:zaid@rapidsoft.co.za" class="text-body">zaid@rapidsoft.co.za</a><br />
            <a href="tel:0027118392645" class="text-body">+27 11 839 2645</a><br />
            
          </p>
        </div>

        <div class="col-md-6 col-lg-3 my-3">
          <i class="lni lni-map-marker text-primary font-size-26 mb-3"></i>
          <p>
            11 Magalies Street<br />
            Hurst Hill<br />
            Johannesburg<br />
            2092<br />
          </p>
        </div>

         <div class="col-md-6 col-lg-3 my-3">
          <i class="lni lni-link text-primary font-size-26 mb-3"></i>
          <p>
            <router-link :to="{ name: 'terms' }" class="text-body"
              >- Home</router-link
            ><br />
            <router-link :to="{ name: 'terms' }" class="text-body"
              >- Sign Up</router-link
            ><br />
            <router-link :to="{ name: 'terms' }" class="text-body"
              >- Pricing</router-link
            ><br />
            <router-link :to="{ name: 'terms' }" class="text-body"
              >- Contact</router-link
            ><br />
          </p>
        </div>

         <div class="col-md-5 col-lg-3 my-3 mt-auto">
          <p>
            © Copyright 2021 propli.xyz.<br />
            All Rights Reserved.
          </p>
        </div>

      </div>


      
<div class="row">
  <div class="col">
    <div class="border-top border-bottom py-3 my-5">
      <div id="share-buttons">
          <h6>Share</h6>
            <!-- Facebook -->
          <a href="https://www.facebook.com/sharer.php?u=https://propli.xyz" target="_blank" class="mr-3">
            <img src="https://simplesharebuttons.com/images/somacro/facebook.png" alt="Facebook">
          </a>

      
          <!-- Twitter -->
          <a href="https://twitter.com/share?url=https://propli.xyz&amp;text=Propli-Property and Renatal Management made easy&amp;hashtags=propli" target="_blank" class="mr-3">
            <img src="https://simplesharebuttons.com/images/somacro/twitter.png" alt="Twitter">
          </a>


          <!-- Email -->
          <a href="mailto:?Subject=Ramadaan Shoebox Project&amp;Body=I%20saw%20this%20and%20thought%20of%20you!%20 https://rsbp.co.za">
            <img src="https://simplesharebuttons.com/images/somacro/email.png" alt="Email">
          </a>




        </div>
    </div>
  </div>
</div>


      <div class="row py-5">
        <div class="col">
          <p class="m-0">Propli, is a product of <a href="https://rapisoft.co.za" class="text-body">rapidsoft.co.za</a></p>
          <router-link :to="{ name: 'terms' }"
            >Terms &amp; Conditions</router-link
          >
          |
          <router-link :to="{ name: 'disclaimer' }">Disclaimer</router-link>
          |
          <router-link :to="{ name: 'privacy' }">Privacy Policy</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
</style>